<ion-row class="main-row">
	<ion-col class="ion-no-padding main-col">
		@if (order?.preorder) {
			<ion-card>
				<ion-card-content class="border-top">
					<ion-row class="ion-align-items-center">
						<ion-col class="header" size="6"> {{ 'payment_success_page.overview' | translate }} {{ order?.code }} </ion-col>
						<ion-col class="reorder-section" size="6">
							<div (click)="reorder()" [class.disabled]="loading" class="reorder">
								{{ 'my_order.reorder' | translate }}
							</div>
						</ion-col>
					</ion-row>
				</ion-card-content>
				<!-- <ion-card-content *ngIf="order?.status !== os.DONE && order?.preorder?.type == pt.DELIVERY">
                <ion-row>
                  <ion-col size="12">
                    <div class="delivery-info">
                      <h3>Order delivery info</h3>
                      <div class="btn" (click)="checkDelivery(order)">Check status</div>
                    </div>
                  </ion-col>
                </ion-row>
              </ion-card-content> -->
				<ion-card-content>
					<ion-row>
						<ion-col>
							<h3>{{ 'payment_success_page.order_number' | translate }}</h3>
						</ion-col>
						<ion-col class="flex">
							{{ order?.code }}
						</ion-col>
					</ion-row>
					<ion-row>
						<ion-col>
							<h3>{{ 'payment_success_page.order_type' | translate }}</h3>
						</ion-col>
						<ion-col class="flex">
							{{ order.preorder.type }}
						</ion-col>
					</ion-row>
					@if (!showMinInfo) {
						<ion-row>
							<ion-col>
								<h3>{{ 'payment_success_page.date_time' | translate }}</h3>
							</ion-col>
							<ion-col>
								{{ formatTime(order.orderAt) }}
							</ion-col>
						</ion-row>
					}
					@if (!showMinInfo) {
						<ion-row>
							<ion-col>
								<h3>{{ 'payment_success_page.name' | translate }}</h3>
							</ion-col>
							<ion-col>
								{{ order.preorder.name }}
							</ion-col>
						</ion-row>
					}
					@if (!showMinInfo) {
						<ion-row>
							<ion-col>
								<h3>{{ 'payment_success_page.email' | translate }}</h3>
							</ion-col>
							<ion-col>
								{{ order.preorder.email }}
							</ion-col>
						</ion-row>
					}
					@if (!showMinInfo) {
						<ion-row>
							<ion-col>
								<h3>{{ 'payment_success_page.phone' | translate }}</h3>
							</ion-col>
							<ion-col> {{ order.preorder.phone }}</ion-col>
						</ion-row>
					}
					@if (!showMinInfo) {
						<ion-row>
							<ion-col>
								<h3>{{ 'payment_success_page.payment_method' | translate }}</h3>
							</ion-col>
							<ion-col>
								{{ order.method | translate }}
							</ion-col>
						</ion-row>
					}
					<ion-row>
						<ion-col>
							<h3>{{ 'common.location' | translate }}</h3>
						</ion-col>
						<ion-col>
							{{ order.venueName | translate }}
						</ion-col>
					</ion-row>
				</ion-card-content>
				<ion-card-content>
					@for (oa of order.orderedArticles; track oa) {
						<ion-row>
							<ion-col size="8">
								<h3>{{ oa.article.name | langObservable | async }} x{{ oa.quantity }}</h3>
								@for (option of oa.groups; track option) {
									<div>
										{{ option.article.name | langObservable | async }}
									</div>
								}
							</ion-col>
							<ion-col size="4">
								<b>
									{{ numberToCurrency(OrderUtils.totalPrice(oa, order.type, order.preorder.type), order.currency) }}
								</b>
							</ion-col>
						</ion-row>
					}
					@if (order.preorder.note && order.preorder.note.length > 0) {
						<ion-row>
							<ion-col size="8">
								<h3>{{ 'payment_success_page.note' | translate }}</h3>
							</ion-col>
							<ion-col size="4">{{ order.preorder.note }}</ion-col>
						</ion-row>
					}
				</ion-card-content>
				<ion-card-content class="border-bottom">
					<ion-row class="header">
						<ion-col size="8">
							<h3>{{ 'payment_success_page.summary' | translate }}</h3>
						</ion-col>
						<ion-col size="4">
							<h3 class="right-col">{{ OrderUtils.formattedOrderTotalPrice(order, true, true) }}</h3>
						</ion-col>
					</ion-row>
				</ion-card-content>
			</ion-card>
		}
	</ion-col>
</ion-row>
